const mountOptions = {
	BEFORE: 'before',
	AFTER: 'after',
	APPEND: 'append',
	REPLACE: 'replace'
}

export default mountOptions
